export const DEFAULT_API_ERROR_MESSAGE = 'Unknown error occurred';
